import type { BrowserSessionStatus } from "@/platform/api/session-contract"

export const ANONYMOUS_VIEWER = "anonymous"
export const UNRESOLVED_VIEWER = "unresolved"

export const viewerOf = (status: BrowserSessionStatus): string | null => (status.kind === "authenticated" ? status.userUuid : status.kind === "anonymous" ? ANONYMOUS_VIEWER : null)

export const privateKey = (viewer: string, ...parts: readonly unknown[]) => [viewer, ...parts] as const

export const isPrivateQuery = (query: { meta?: Record<string, unknown> | undefined }): boolean => typeof query.meta?.viewer === "string"
